import type {
  PreSalesProjectIndexT,
  FormattedPreSalesProjectIndexT,
} from "rdx/modules/projects/types/projects/pre-sales";

const isPreSalesIndexProject = (
  project: PreSalesProjectIndexT | FormattedPreSalesProjectIndexT,
): project is PreSalesProjectIndexT => {
  return (project as PreSalesProjectIndexT).projectId !== undefined;
};

const formatPreSalesIndexData = (
  preSalesProject: PreSalesProjectIndexT | FormattedPreSalesProjectIndexT,
): FormattedPreSalesProjectIndexT => {
  if (!isPreSalesIndexProject(preSalesProject)) return preSalesProject;

  return {
    activities: preSalesProject.activities,
    address: {
      id: preSalesProject.addressId,
      street: preSalesProject.homeowner.address.addressStreet,
      unit: preSalesProject.homeowner.address.addressUnit,
      city: preSalesProject.addressCity,
      state: preSalesProject.addressState,
      zip: preSalesProject.homeowner.address.addressZip,
    },
    auroraFinanceOptions: preSalesProject.auroraFinanceOptions,
    auroraNonRequestableReason: preSalesProject.auroraNonRequestableReason,
    canRequestTpoPricing: preSalesProject.canRequestTpoPricing,
    updatedAt: preSalesProject.coalescedUpdatedAt,
    contractOut: preSalesProject.contractOut,
    currentOfferId: preSalesProject.currentOfferId,
    hasCurrentOffer: preSalesProject.hasCurrentOffer,
    hasExistingSystem: preSalesProject.hasExistingSystem,
    hasProposals: preSalesProject.hasProposals,
    homeowner: {
      firstName: preSalesProject.homeowner.leadFirstName,
      lastName: preSalesProject.homeowner.leadLastName,
      address: {
        id: preSalesProject.addressId,
        street: preSalesProject.homeowner.address.addressStreet,
        unit: preSalesProject.homeowner.address.addressUnit,
        city: preSalesProject.addressCity,
        state: preSalesProject.addressState,
        zip: preSalesProject.homeowner.address.addressZip,
      },
      qualificationPercent: preSalesProject.leadQualificationPercent,
    },
    id: preSalesProject.projectId || preSalesProject.leadId,
    isFastPayPreferred: preSalesProject.isFastPayPreferred,
    isUserLeadGen: preSalesProject.isUserLeadGen,
    isValidServiceArea: preSalesProject.isValidServiceArea,
    latestProposalRejection: preSalesProject.latestProposalRejection,
    latestProposal: preSalesProject.latestProposal || null,
    lead: {
      id: preSalesProject.leadId,
      email: preSalesProject.leadEmail,
      phone: preSalesProject.leadPhone,
      firstName: preSalesProject.leadFirstName,
      lastName: preSalesProject.leadLastName,
      fullName: `${preSalesProject.leadFirstName} ${preSalesProject.leadLastName}`,
      kind: preSalesProject.leadKind,
      referrerId: preSalesProject.leadReferrerId,
      userId: preSalesProject.leadOwnerId,
      address: {
        id: preSalesProject.addressId,
        street: preSalesProject.homeowner.address.addressStreet,
        unit: preSalesProject.homeowner.address.addressUnit,
        city: preSalesProject.addressCity,
        state: preSalesProject.addressState,
        zip: preSalesProject.homeowner.address.addressZip,
      },
    },
    leadId: preSalesProject.leadId,
    enterpriseId: preSalesProject.enterpriseId,
    entOwnerId: preSalesProject.entOwnerId,
    email: preSalesProject.leadEmail,
    phone: preSalesProject.leadPhone,
    firstName: preSalesProject.leadFirstName,
    lastName: preSalesProject.leadLastName,
    leadQualificationPercent: preSalesProject.leadQualificationPercent,
    lightreachProposalNonrequestableReason: preSalesProject.lightreachProposalNonrequestableReason,
    milestoneDisplayName: preSalesProject.milestoneDisplayName,
    offer: preSalesProject.offer,
    offerable: preSalesProject.offerable,
    passedStageNames: preSalesProject.passedStageNames,
    perWattStrategyId: preSalesProject.perWattStrategyId,
    managerId: preSalesProject.projectManagerId,
    mentorId: preSalesProject.projectMentorId,
    agentId: preSalesProject.projectSellerId,
    stageId: preSalesProject.projectStageId,
    milestoneName: preSalesProject.projectStageMilestoneName,
    stageName: preSalesProject.projectStageName,
    stageScore: preSalesProject.projectStageScore,
    status: preSalesProject.projectStatus,
    projectType: preSalesProject.projectType,
    projectUsers: preSalesProject.projectUsers,
    proposalNonrequestableReason: preSalesProject.proposalNonrequestableReason,
    proposalUrl: preSalesProject.proposalUrl,
    qualifyAt: preSalesProject.qualifyAt,
    closeAt: preSalesProject.closeAt || null,
    requiresRsm: preSalesProject.requiresRsm,
    roofingNonRequestableReason: preSalesProject.roofingNonRequestableReason,
    siteId: preSalesProject.siteId,
    soloProposalNonrequestableReason: preSalesProject.soloProposalNonrequestableReason,
    tickets: preSalesProject.tickets,
    upcomingStageNames: preSalesProject.upcomingStageNames,
    visionProposal: preSalesProject.visionProposal || null,
    visionProposalNonrequestableReason: preSalesProject.visionProposalNonrequestableReason,
  };
};

export default formatPreSalesIndexData;
